import { AfterViewInit, Component, ElementRef, ChangeDetectionStrategy, input, output, viewChild } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { interval, merge, takeUntil, tap, timer } from 'rxjs';
import { Answer, Async } from 'shared';

@Component({
  selector: 'app-explanation',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './explanation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './explanation.component.scss',
})
export class ExplanationComponent implements AfterViewInit {
  readonly currentAnswer = input<Answer | null>();
  readonly explanation = input<Async<string>>();

  readonly explanationSubmit = output<string>();

  readonly _textArea = viewChild<ElementRef>('textArea');

  explanationForm = new FormGroup({
    explanation: new FormControl('', Validators.required),
  });
  explanationTimer: number = 180000; // 3 minutes in ms
  showError = false;

  constructor() {
    const timerTimedOut$ = timer(this.explanationTimer).pipe(
      tap(() => {
        this.explanationForm.patchValue({
          explanation: 'De speler heeft geen toelichting gegeven bij het antwoord dat gekozen is',
        });
        this.onExplanationSubmit();
      }),
    );

    interval(1000)
      .pipe(takeUntil(merge(outputToObservable(this.explanationSubmit), timerTimedOut$)))
      .subscribe();
  }

  ngAfterViewInit(): void {
    const textArea = this._textArea()?.nativeElement as HTMLTextAreaElement;
    textArea.focus();
  }

  onExplanationSubmit() {
    this.showError = !this.explanationForm?.valid;
    if (this.explanationForm?.valid) {
      this.explanationSubmit.emit(this.explanationForm.value.explanation as string);
      this.explanationForm.reset();
    }
  }
}
